import Copy16 from '@carbon/icons-react/es/copy/16';
import { Typography } from 'antd';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import useSound from 'use-sound';
import { useTranslation } from 'hooks/use-translation';
import { Button } from './styles';

interface Props {
  popoverText?: string;
  textToCopy: string;
  icon?: JSX.Element;
}

export const CopyToClipboard: FC<Props> = ({
  popoverText,
  textToCopy,
  icon,
}) => {
  const copyPopovertext = useTranslation('click_to_copy');
  const copiedPopoverText = useTranslation('copied');
  const { Text } = Typography;

  const [playSound] = useSound('/sounds/dot-success.ogg');

  const translatedClickToCopyText = !isEmpty(popoverText)
    ? popoverText
    : copyPopovertext;

  return (
    <Button
      data-cy="copy_to_clipboard"
      type="text"
      size="small"
      onClick={() => playSound()}
    >
      <Text
        copyable={{
          text: textToCopy,
          icon: icon ?? <Copy16 />,
          tooltips: [translatedClickToCopyText, copiedPopoverText],
        }}
      />
    </Button>
  );
};
